export const chargeServicesDrawer = {
  title: "Cobranças e serviços",
  closeAria: "Fechar",
  subtitle: {
    catalog: "Catálogo reutilizável para suas faturas",
    select: "Selecione os itens que deseja adicionar",
  },
  searchPlaceholder: "Buscar serviço…",
  createService: "Criar serviço",
  loading: "Carregando serviços…",
  empty: "Você ainda não tem serviços. Crie o seu primeiro.",
  item: {
    vat: "IVA {vat}%",
    edit: "Editar",
    delete: "Excluir",
  },
  footer: {
    selected: "{count} selecionado | {count} selecionados",
    createInvoice: "Criar fatura com estes",
    addToInvoice: "Adicionar à fatura",
  },
  form: {
    editTitle: "Editar serviço",
    newTitle: "Novo serviço",
    subtitle: "Item reutilizável para suas faturas",
    photoLabel: "Foto",
    optional: "opcional",
    uploadPhoto: "Enviar",
    nameLabel: "Nome",
    namePlaceholder: "ex.: Limpeza final",
    categoryLabel: "Categoria",
    categoryPlaceholder: "ex.: Limpeza",
    priceLabel: "Preço",
    vatLabel: "IVA",
    descriptionLabel: "Descrição",
    descriptionPlaceholder: "Detalhe exibido na fatura",
    cancel: "Cancelar",
    save: "Salvar alterações",
    create: "Criar serviço",
  },
  toasts: {
    loadError: "Não foi possível carregar os serviços.",
    photoError: "Não foi possível enviar a foto.",
    updated: "Serviço atualizado.",
    created: "Serviço criado.",
    saveError: "Não foi possível salvar o serviço.",
    deleteError: "Não foi possível excluir.",
  },
  confirmDelete: 'Excluir "{name}" do catálogo?',
};